import api from "../services/api";

// Helper function to handle API responses
const handleApiResponse = (response) => {
  if (response.status === 200) {
    return response.data; // Return the data if response is successful
  } else {
    console.warn("Unexpected Response:", response);
    return { error: "Unexpected response from server" };
  }
};

// Helper function to handle API errors
const handleApiError = (error) => {
  console.error("Error fetching data:", error);
  return { error: error.message };
};

// Fetch total count of records from a specific table
export const fetchTotalCount = async (tableName, status = null) => {
  try {
    const url = status
      ? `/analytics/total/${tableName}/count?status=${status}`
      : `/analytics/total/${tableName}/count`;

    const response = await api.get(url);
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch total revenue from a specific table
export const fetchTotalRevenue = async (tableName) => {
  try {
    const response = await api.get(`/analytics/revenue/${tableName}`);
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch data by date (e.g., packages created, deliveries)
export const fetchDataByDate = async (tableName, days = 30) => {
  try {
    const response = await api.get(`/analytics/data-by-date/${tableName}`, {
      params: { days },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch status distribution (e.g., status counts of deliveries)
export const fetchStatusDistribution = async (tableName) => {
  try {
    const response = await api.get(`/analytics/status-distribution/${tableName}`);
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch top drivers by number of deliveries
export const fetchTopDrivers = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/top-drivers", {
      params: { limit },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch top users by total spending
export const fetchTopUsersBySpending = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/top-users-by-spending", {
      params: { limit },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch top users by number of packages created
export const fetchTopUsersByPackages = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/top-users-by-packages", {
      params: { limit },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch Recent transactions with Username, date and amount
export const fetchRecentTransactions = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/recent-transactions", {
      params: { limit },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Fetch district reports (e.g., most packages created by district)
export const fetchDistrictReports = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/district-reports", {
      params: { limit },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//claims summary
export const fetchClaimsAnalyticsSummary = async (start, end) => {
  try {
    const response = await api.get("/analytics/claims/summary", {
      params: { start, end },
    });
    return handleApiResponse(response);
  } catch (error) {
    return handleApiError(error);
  }
};